import React from 'react';
import { history } from 'store';
import { Button } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import ProjectAdd from '../projectAdd/index';
import ProjectDetailTable from './projectDetailTable';
import ProjectPriorities from './projectPriorities';
import { getProjectDisplayData } from 'services/projectService';

class ProjectDetail extends React.Component {
    constructor() {
        super();
        this.state = {
            addProjectState: false,
        };
    }

    onProjectClose = () => {
        this.setState({ addProjectState: false });
    };
    onDeleteProject = (project) => {
        this.setState({ addProjectState: false });
        this.props.onDeleteProject(project);
    };
    onEditProject = () => {
        this.setState({ addProjectState: true });
    };
    // the next 2 go to the same view but the reducer will have different data to display
    onProjectCostPrioritiesDashboard = (project) => {
        this.setState({ addProjectState: false });
        this.props.onProjectPrioritiesDashboard(project);
        this.props.onProjectCostPrioritiesDashboard(project);
        history.push('/app/projectPriority/default');
    }
    onProjectBusinessPrioritiesDashboard = (project) => {
        this.setState({ addProjectState: false });
        this.props.onProjectPrioritiesDashboard(project);
        this.props.onProjectBusinessPrioritiesDashboard(project);
        history.push('/app/projectPriority/default');
    }
    onProjectIssuesDashboard = (project) => {
        this.setState({ addProjectState: false });
        this.props.onProjectIssuesDashboard(project);
        history.push('/app/projectIssue/default');
    };
    render() {
        const {
            selectedProject,
            onSaveProject,
            showProjectLoader,
            initiatives,
        } = this.props;
        const { addProjectState } = this.state;

        if (selectedProject) {
            const displayData = getProjectDisplayData(selectedProject);
            return (
                <div className="dashboard animated slideInUpTiny animation-duration-3">
                    <div className="row">
                        <div className="col-md-6 col-12">
                            <div className="jr-card jr-card-full-height">
                                <div className="jr-card-header d-flex">
                                    <div className="mr-auto">
                                        <h2 className="card-heading">{displayData?.summary}</h2>
                                    </div>
                                    <div>
                                        <Button size="sm" color="primary" onClick={() => this.onEditProject()}>
                                            <i className="zmdi zmdi-edit zmdi-hc-fw" />
                                            <span>{<IntlMessages id="label.edit" />}</span>
                                        </Button>
                                        {/* <Button size="sm" color="secondary" onClick={() => this.onDeleteProject(selectedProject)}>
                                            <i className="zmdi zmdi-delete zmdi-hc-fw" />
                                            <span>{<IntlMessages id="label.delete" />}</span>
                                        </Button> */}
                                        <Button size="sm" color="secondary" onClick={() => this.onProjectCostPrioritiesDashboard(selectedProject)}>
                                            <i className="zmdi zmdi-trending-up zmdi-hc-fw" />
                                            <span>{<IntlMessages id="project.updateProjectCostPriorities" />}</span>
                                        </Button>
                                        <Button size="sm" color="secondary" onClick={() => this.onProjectBusinessPrioritiesDashboard(selectedProject)}>
                                            <i className="zmdi zmdi-trending-up zmdi-hc-fw" />
                                            <span>{<IntlMessages id="project.updateProjectBusinessPriorities" />}</span>
                                        </Button>
                                        <Button size="sm" color="secondary" onClick={() => this.onProjectIssuesDashboard(selectedProject)}>
                                            <i className="zmdi zmdi-trending-up zmdi-hc-fw" />
                                            <span>{<IntlMessages id="project.projectIssues" />}</span>
                                        </Button>
                                    </div>
                                </div>
                                <div className="jr-card-body">
                                    <div className="row">
                                        <div className="col-sm-3">
                                            <div className="temp-section mb-4 mb-sm-0 text-center text-sm-left">
                                                <p>
                                                    {/* <div className={`btn btn-sm text-uppercase btn-rounded ${style}`}>{order} Order</div> */}
                                                    <i className="detail-icon text-blue-grey zmdi zmdi-collection-plus zmdi-hc-fw" />
                                                </p>
                                                {displayData?.weight ?
                                                    <h2 className="temp-point">{displayData?.weight}</h2>
                                                    : null
                                                }
                                            </div>
                                        </div>
                                        <div className="col-sm-9 text-center text-sm-left">
                                            <ProjectDetailTable displayData={displayData} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="jr-card jr-card-full-height">
                                <ProjectPriorities priorities={selectedProject?.busValPriorityParams} title={<IntlMessages id="project.busValuePriorities" />} />
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="jr-card jr-card-full-height">
                                <ProjectPriorities priorities={selectedProject?.costImplPriorityParams} title={<IntlMessages id="project.costImplPriorities" />} />
                            </div>
                        </div>

                    </div>
                    <div>
                        {addProjectState &&
                            <ProjectAdd
                                open={addProjectState}
                                project={selectedProject}
                                onSaveProject={onSaveProject}
                                onProjectClose={this.onProjectClose}
                                onDeleteProject={this.onDeleteProject}
                                showProjectLoader={showProjectLoader}
                                initiatives={initiatives}
                            />
                        }
                    </div>
                </div>
            );
        } else {
            return (
                <div className="dashboard animated slideInUpTiny animation-duration-3">
                    <div className="row">
                        <div className="col-md-12 col-12">
                            <div className="jr-card jr-card-full-height">
                                <div className="jr-card-header d-flex">
                                    <div className="mr-auto">
                                        <h3 className="card-heading">Please select a project to display details</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

export default ProjectDetail;


// WEBPACK FOOTER //
// ./components/Agile/project/projectDetail/index.js